<template>
  <GridContainer>
    <div class="progress-tracker">
      <div class="step-container">
        <div v-for="(step, index) in steps" :key="step.title" class="step-wrapper">
          <div :class="{ step: true, active: currentStep >= index }">
            <div v-if="currentStep > index" class="check">
              <i class="fa fa-check" />
            </div>
            {{ step.title }}
          </div>
          <div
            v-if="index < steps.length - 1"
            class="step-line"
            :class="{ active: currentStep > index }"
          ></div>
        </div>
      </div>
    </div>
  </GridContainer>
</template>

<script>
export default {
  name: 'ProgressTracker',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.progress-tracker {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 10px;
}

.step-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.step-wrapper {
  display: flex;
  align-items: center;
}

.step {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  height: 50px;
  border-radius: 10px;
  border: 1px solid var(--accent-grey);
  color: var(--accent-grey);
  white-space: nowrap;
}

.step-line {
  width: 30px;
  height: 2px;
  background-color: var(--accent-grey);
  margin: 0 12px;
}

.active {
  background-color: var(--accent);
  color: var(--white);
}
.check {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50px;
  width: 20px;
  height: 20px;
  color: var(--accent);
  margin-right: 8px;
}
@media (max-width: 600px) {
  .progress-tracker {
    padding: 5px;
  }

  .step-container {
    height: 200px;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
    overflow-y: scroll;
  }

  .step-wrapper {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  .step {
    width: 100%;
    padding: 8px;
    margin-bottom: 4px;
  }

  .step-line {
    visibility: hidden;
    height: 0;
    width: 0;
  }

  .check {
    width: 15px;
    height: 15px;
    margin-right: 4px;
  }
}

@media (max-width: 400px) {
  .progress-tracker {
    padding: 2px;
  }

  .step-container {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }

  .step-wrapper {
    flex-direction: row;
    align-items: center;
    margin-bottom: 0;
  }

  .step {
    padding: 4px;
    height: 40px;
    font-size: 0.8em;
  }

  .check {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}
</style>
